import { useState } from 'react';

import Locator from '../../../../shared/Locator';

import type { DependencyToRemove } from './types';

/**
 * Hook that manages state for ModalRemoveDependency
 */
const useModalRemoveDependency = () => {
  const [dependencyToRemove, setDependencyToRemove] = useState<DependencyToRemove | null>(null);

  const removeDependency = (locator: string, isManual: boolean) => {
    const { package: packageName, revision: revisionValue } = Locator.parse(locator);
    const dependencyToRemoveData: DependencyToRemove = {
      locator,
      packageName: packageName ?? '',
      revision: revisionValue ?? '',
      isManual,
    };

    setDependencyToRemove(dependencyToRemoveData);
  };

  return {
    dependencyToRemove,
    setDependencyToRemove,
    removeDependency,
  };
};

export default useModalRemoveDependency;
